import * as Sentry from '@sentry/browser';
import config, { configResponse } from '../trackConfig/config';

const setVnodeParameters = (parameters, args, vnode) => {
  const params = { ...parameters };
  args.forEach((e) => {
    const keys = Object.keys(e);
    const idxObjectName = keys.indexOf('objectName');
    let objectName = null;
    if (idxObjectName !== -1) {
      objectName = e[keys[idxObjectName]];
      keys.splice(idxObjectName, 1);
    }
    keys.forEach((i) => {
      if (objectName) params[e[i]] = vnode.context[objectName][i];
      else params[e[i]] = vnode.context[i];
    });
  });
  return params;
};

const setParameters = (type, event, args, vnode = null) => {
  let parameters = {};
  if (type === 'clicks') {
    const evt = config.clicks[event];
    parameters = evt.parameters;
    if (args.parameters) parameters = { ...evt.parameters, ...args.parameters };

    if (args.model && vnode) parameters = setVnodeParameters(parameters, args.model, vnode);
  } else if (type === 'requests') {
    parameters = config.requests[event].parameters;

    try {
      if (configResponse[args.response.data.status]) {
        parameters = { ...parameters, ...configResponse[args.response.data.status].parameters };
      }
    } catch (error) {
      Sentry.captureException(new Error(`Tracker response undefined - ${event} - ${type}`));

      return parameters;
    }

    if (configResponse[args.response.data.status]) {
      parameters = { ...parameters, ...configResponse[args.response.data.status].parameters };
    }

    const params = Object.keys(parameters);

    if (params.includes('status')) parameters.status = args.response.data.status;
    if (params.includes('error')) parameters.error = args.response.data.errors[0].id;
    if (params.includes('code')) parameters.code = args.response.status;

    if (args.method === 'post' && args.endpoint === 'accountManagement/reportRequests') {
      parameters.NOBO = (args.response.data.data && args.response.data.data.is_nobo_requested);
      parameters.DTCC = (args.response.data.data && args.response.data.data.is_spr_requested);
    }

    if (args.method === 'post' && args.endpoint === 'accountManagement/reportReviews') {
      parameters.NOBO = (args.response.data.data && args.response.data.data.nobo_review);
      parameters.DTCC = (args.response.data.data && args.response.data.data.spr_review);
    }

    if (args.method === 'post' && args.endpoint === 'accountManagement/reportRequestsContact') {
      parameters.report_request_contact_type = args.response.data.data.report_request_contact_type;
    }
  }

  return parameters;
};

export default {
  validateEvent(args, vnode = null) {
    if (args.event) {
      const { clicks } = config;
      const event = args.event;
      if (!Object.prototype.hasOwnProperty.call(clicks, event)) return false;
      const parameters = setParameters('clicks', event, args, vnode);
      let userAttributes = {};
      if (args.userAttributes) {
        userAttributes = setVnodeParameters(userAttributes, args.userAttributes, vnode);
      }
      return {
        event,
        parameters,
        config: clicks[event],
        userAttributes,
      };
    }
    const { requests } = config;
    if (args.event_name) {
      if (Object.keys(requests).includes(args.event_name)) {
        const event = args.event_name;
        const parameters = setParameters('requests', event, args);
        return { event, parameters, config: requests[event] };
      }
      return false;
    }
    let event = '';
    let parameters = {};
    const evt = Object.keys(requests).filter((e) => requests[e].endpoint === args.endpoint);
    evt.forEach((e) => {
      if (requests[e].method === args.method) {
        if (!requests[e].isSearch) {
          event = e;
          parameters = setParameters('requests', event, args);
        }
      }
    });
    if (event) {
      return {
        event: requests[event].event_name ? requests[event].event_name : event,
        parameters,
        config: requests[event],
      };
    }
    return false;
  },
};
